window.customElements.define(
    "auto-submit",
    class extends HTMLElement {
        connectedCallback() {
            this.addEventListener(
                "change",
                (event) => {
                    const target = event.target as HTMLElement | null;
                    const form = target?.closest("form") ?? this.querySelector("form");

                    form?.submit();
                },
            );
        }
    },
);
